import { Form, Input, Modal } from 'antd';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { regexDescription, regexInput } from 'utils/regex';
import { log } from 'utils';
import { tagsCleanUp } from 'state/actions/tag';

const ModalTagForm = ({
  tag,
  setTag,
  visible,
  onCancel,
  onCreate,
  isEditing,
}) => {
  const [form] = Form.useForm();

  const { loading } = useSelector(
    (state) => ({
      loading: state.tags.loading,
    }),
    shallowEqual
  );

  const [errors, setErrors] = useState({ name: '' });
  const dispatch = useDispatch();

  useEffect(() => {
    return () => dispatch(tagsCleanUp());
  }, [dispatch]);

  const handleChange = (name, value) => {
    setTag({
      ...tag,
      [name]: value,
    });
  };

  const onSave = (values) => {
    if (!regexInput(values.name) && values.name) {
      setErrors({
        name:
          !regexInput(values.name) &&
          values.name &&
          'This field cannot contain any special characters',
      });
    } else {
      setErrors({ name: '' });
      onCreate({
        ...tag,
        id: tag._id,
        name: tag.name,
      });
      form.resetFields();
    }
  };

  return (
    <Modal
      className="adsign-modal"
      visible={visible}
      title={isEditing ? 'Edit Tag' : 'Add New Tag'}
      closeIcon={<i className="feather-x" />}
      okText="Submit"
      okButtonProps={{
        className: 'button-submit',
      }}
      cancelButtonProps={{
        className: 'button-cancel',
      }}
      confirmLoading={loading}
      onCancel={() => {
        onCancel();
        form.resetFields();
      }}
      onOk={() => {
        form
          .validateFields()
          .then((values) => {
            onSave(values);
          })
          .catch((info) => {
            log('Validate Failed:', info);
          });
      }}
    >
      <Form
        layout="vertical"
        form={form}
        // onChange={onChangeHandler}
      >
        <Form.Item
          label="Name"
          rules={[{ required: true, message: `'Name' is required` }]}
          validateStatus={errors.name ? 'error' : 'success'}
          help={errors.name ? errors.name : null}
        >
          <Input
            value={tag.name}
            placeholder="Enter tag's name"
            onChange={(e) => handleChange('name', e.target.value)}
          />
        </Form.Item>
      </Form>
    </Modal>
  );
};

ModalTagForm.propTypes = {
  tag: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
    description: PropTypes.string,
    orientation: PropTypes.string,
  }),
  setTag: PropTypes.func.isRequired,
  visible: PropTypes.bool,
  onCancel: PropTypes.func,
  onCreate: PropTypes.func,
  isEditing: PropTypes.bool,
};

export default ModalTagForm;